<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">عرض التحديث</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link :to="`/properties/update/${proId}`">العقار</router-link></li>
              <li class="breadcrumb-item"><router-link :to="`/regaUpdates/${proId}`">تحديثات الهيئة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">عرض التحديث</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
          </div>
        </div>
        <div v-if="!mainLoading" class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <!--begin::Header-->
              <div class="card-header"><div class="card-title">عرض التحديث</div></div>
              <!--begin::Body-->
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-if="!mainLoading" class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">نوع العملية:</label>
                        <div>{{ row.updatedData.operationType }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">سبب العملية:</label>
                        <div>{{ row.updatedData.operationReason }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رابط الإعلان في المنصة العقارية:</label>
                        <div>{{ row.updatedData.adLinkInPlatform }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم ترخيص الإعلان:</label>
                        <div>{{ row.updatedData.adLicenseNumber }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم رخصة الوساطة والتسويق / رخصة فال للوساطة والتسويق للمنصات العقارية الإلكترونية</label>
                        <div>{{ row.updatedData.brokerageAndMarketingLicenseNumber }}</div>
                        <div class="form-text">رقم رخصة الوساطة والتسويق للمعلن إذا كان المعلن وسيطاً عقارياً ، أما إذا كان المعلن هو مالك العقار أو ممثله فلا يتم إرسال قيمة في هذا الحقل</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم وثيقة الملكية / ملكية المنفعة:</label>
                        <div>{{ row.updatedData.titleDeedNumber }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">تاريخ إنشاء ترخيص الإعلان:</label>
                        <div>{{ row.updatedData.creationDate }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">تاريخ إنتهاء ترخيص الإعلان:</label>
                        <div>{{ row.updatedData.endDate }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم هوية المُعلن:</label>
                        <div>{{ row.updatedData.advertiserID }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">اسم المُعلن:</label>
                        <div>{{ row.updatedData.advertiserName }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم التواصل للمُعلن:</label>
                        <div>{{ row.updatedData.advertiserMobile }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">قنوات الإعلان:</label>
                        <div>{{ row.updatedData.channels }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">العنوان الوطني:</label>
                        <div>{{ row.updatedData.nationalAddress }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">واجهة العقار</label>
                        <div>{{ row.updatedData.propertyFace }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">نوع العقار:</label>
                        <div>{{ row.updatedData.propertyType }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">مساحة العقار:</label>
                        <div>{{ row.updatedData.propertyArea }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">استخدام العقار:</label>
                        <div>{{ row.updatedData.propertyUsage }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">عرض الشارع:</label>
                        <div>{{ row.updatedData.streetWidth }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">عمر العقار:</label>
                        <div>{{ row.updatedData.propertyAge }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">سعر المتر للارض / سعر الوحدة:</label>
                        <div>{{ row.updatedData.price }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">عدد الغرف:</label>
                        <div>{{ row.updatedData.roomsNumber }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">خدمات العقار:</label>
                        <div>{{ row.updatedData.propertyUtilities }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">غرض الإعلان:</label>
                        <div>{{ row.updatedData.adType }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">يوجد قيود على العقار؟:</label>
                        <div>{{ row.updatedData.isConstrained }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">الإلتزامات على العقار:</label>
                        <div>{{ row.updatedData.obligationsOntheProperty }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">الضمانات ومدتها:</label>
                        <div>{{ row.updatedData.guaranteesAndTheirDuration }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم المخطط:</label>
                        <div>{{ row.updatedData.planNumber }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم القطعة:</label>
                        <div>{{ row.updatedData.landNumber }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">مطابقة كود البناء السعودي؟</label>
                        <div>{{ row.updatedData.complianceWithTheSaudiBuildingCode }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رابط ترخيص الإعلان العقاري:</label>
                        <div>{{ row.updatedData.adLicenseURL }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">نوع وثيقة الملكية / المنفعة:</label>
                        <div>{{ row.updatedData.titleDeedType }}</div>
                      </div>
                    </div>

                    <div class="row mb-3"><div class="col"><hr /></div></div>
                      <div class="row">
                        <div class="col">في حال كان الصك لم يكن صادر من السجل العقاري ، بمعنى انه إذا كانت وثيقة الملكية صك إلكتروني صادر من وزارة العدل أو كانت أحد وثائق الملكية أو ملكية المنفعة غير الإلكترونية </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">نوع الحد الشمالي:</label>
                          <div>{{ row.updatedData.northLimitName }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">وصف الحد الشمالي:</label>
                          <div>{{ row.updatedData.northLimitDescription }}</div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">طول الحد الشمالي:</label>
                          <div>{{ row.updatedData.northLimitLengthChar }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">نوع الحد الشرقي:</label>
                          <div>{{ row.updatedData.eastLimitName }}</div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">وصف الحد الشرقي:</label>
                          <div>{{ row.updatedData.eastLimitDescription }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">طول الحد الشرقي:</label>
                          <div>{{ row.updatedData.eastLimitLengthChar }}</div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">نوع الحد الغربي:</label>
                          <div>{{ row.updatedData.westLimitName }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">وصف الحد الغربي:</label>
                          <div>{{ row.updatedData.westLimitDescription }}</div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">طول الحد الغربي:</label>
                          <div>{{ row.updatedData.westLimitLengthChar }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">نوع الحد الجنوبي:</label>
                          <div>{{ row.updatedData.southLimitName }}</div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">وصف الحد الجنوبي:</label>
                          <div>{{ row.updatedData.southLimitDescription }}</div>
                        </div>
                        <div class="col-12 col-sm-6 mb-3">
                          <label for="" class="form-label">طول الحد الجنوبي:</label>
                          <div>{{ row.updatedData.southLimitLengthChar }}</div>
                        </div>
                      </div>
                    <div class="row mb-3"><div class="col"><hr /></div></div>
                      <div class="row"><div class="col">الحدود: في حال كان الصك صادر من السجل العقاري</div></div>
                      <div class="row">
                        <div class="col-12">
                          <div>{{ row.updatedData.borders }}</div>
                        </div>
                      </div>
                    <div class="row mb-3"><div class="col"><hr /></div></div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">مصدر ترخيص الإعلان:</label>
                        <div>{{ row.updatedData.adSource }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">اجمالي سعر بيع الارض:</label>
                        <div>{{ row.updatedData.landTotalPrice }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">اجمالي الإيجار السنوي للارض:</label>
                        <div>{{ row.updatedData.totalAnnualRentForTheLand }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">الملاحظات:</label>
                        <div>{{ row.updatedData.notes }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">وصف موقع العقار حسب الصك:</label>
                        <div>{{ row.updatedData.locationDescriptionAccordingToDeed }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رسوم نقل الملكية:</label>
                        <div>{{ row.updatedData.ownershipTransferFeeType }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">مسؤول الإعلان:</label>
                        <div>{{ row.updatedData.responsibleEmployeeName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3">
                        <label for="" class="form-label">رقم مسؤول الإعلان:</label>
                        <div>{{ row.updatedData.responsibleEmployeePhoneNumber }}</div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!--end::Body-->
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
export default {
  name: 'RegaUpdatesView',
  data(){
    return {
      proId: this.$route.params.proId,
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      row: null,
    }
  },
  methods: {
    getRowData(){
      this.$http.get(`/api/admin/properties/regaUpdatesRow/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>
